const blankToNull = require('./../../../utils').blankToNull
const {
  isCriterioRemessaFinanceira,
  normalizarAtivo,
  normalizarCriterioRemessa,
  validarTextoCriterio,
} = require('./../criterioRemessa')

export function validate(record) {
  const errors = []
  // O crudFactory grava o record devolvido por aqui, então é este o ponto onde os campos que a tela
  // não mostra (ou mostra só como checkbox) ganham valor válido.
  normalizarAtivo(record)
  normalizarCriterioRemessa(record)

  if (!record.nome) {
    errors.push({
      field: 'nome',
      message: 'O campo Nome é obrigatório',
    })
  }
  if (!record.unidade) {
    errors.push({
      field: 'unidade',
      message: 'O campo Unidade é obrigatório',
    })
  }

  if (!record.tipo) {
    errors.push({
      field: 'tipo',
      message: 'O campo Tipo é obrigatório',
    })
  }

  if (!record.consultaSql) {
    errors.push({
      field: 'consultaSql',
      message: 'O campo Consulta SQL é obrigatório',
    })
  }
  // O critério da remessa (PHOENIX-943) não gera requisição: Requisição e Formato não se aplicam a
  // ele — o backend preenche o formato sozinho. Em troca, o texto passa pelas regras do critério.
  if (isCriterioRemessaFinanceira(record)) {
    const erroCriterio = record.consultaSql ? validarTextoCriterio(record.consultaSql) : null
    if (erroCriterio) {
      errors.push({
        field: 'consultaSql',
        message: erroCriterio,
      })
    }
  } else {
    if (!record.requisicao) {
      errors.push({
        field: 'requisicao',
        message: 'O campo Requisiçãpo é obrigatório',
      })
    }
    if (!record.formato) {
      errors.push({
        field: 'formato',
        message: 'O campo Formato é obrigatório',
      })
    }
  }

  blankToNull(record)
  const result = {
    ok: errors.length === 0,
    errors,
    record,
  }
  return new Promise((resolve, reject) => {
    const action = result.ok ? resolve : reject
    return action(result)
  })
}
